module.exports = __webpack_public_path__ + "img/water_droplet_2.75f9aa70.svg";